import { useState } from 'react'

interface LoginFormProps {
  onLogin: (email: string) => Promise<void>
  loading: boolean
}

export default function LoginForm({ onLogin, loading }: LoginFormProps) {
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [validationError, setValidationError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    
    if (!email.trim()) {
      setValidationError('Email is required')
      return
    }

    if (!email.includes('@')) {
      setValidationError('Please enter a valid email address')
      return
    }

    setValidationError('')
    setIsSubmitting(true)

    try {
      await onLogin(email.trim())
    } catch (error) {
      console.error('Login form error:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  const isInputDisabled = loading || isSubmitting
  const isButtonDisabled = loading || isSubmitting || !email.trim()

  return (
    <div className="flex justify-center items-center" style={{ minHeight: '60vh' }}>
      <div className="card" style={{ width: '100%' }}>
        <div className="text-center mb-4">
          <h2 className="text-lg font-bold mb-4">YYZ Prep Client Login</h2>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            Enter your YYZ Prep client email to access your outbound shipments and classify products with duty rate estimates.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email" className="label">
              Client Email Address
            </label>
            <input
              id="email"
              type="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your-email@company.com"
              disabled={isInputDisabled}
              autoComplete="email"
              autoFocus
            />
            {validationError && (
              <div style={{ color: '#dc3545', fontSize: '14px', marginTop: '5px' }}>
                {validationError}
              </div>
            )}
          </div>

          <button
            type="submit"
            className="button"
            style={{ width: '100%' }}
            disabled={isButtonDisabled}
          >
            {isSubmitting ? 'Verifying...' : 'Access Dashboard'}
          </button>
        </form>

        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '4px', fontSize: '14px', color: '#666' }}>
          <strong>Note:</strong> Only YYZ Prep clients with recent shipment activity (last 3 months) can access this system. No password required - we verify your account automatically.
        </div>
      </div>
    </div>
  )
}